<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @execute="execute" @print='print'
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <wTable
                                :data="dataSet"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadSingleViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2095]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[2198]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4826]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')" sortable ></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[4471]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')" sortable></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <wTable
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadSingleViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange1"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2095]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[2198]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4826]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[4471]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6097]')" name="2">
                        <el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange2"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                            <el-table-column prop="order_statusname" :label="$t('getapi[1861]')">
                                <template scope="scope">
                                    <span>{{ scope.row.order_statusname | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2095]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[2198]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4826]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column prop="finance_status" :label="$t('getapi[1862]')">
                                <template scope="scope">
                                    <span>{{ scope.row.finance_status | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[4471]')"></el-table-column>
                            <el-table-column prop="negative_flag" :label="$t('getapi[2096]')">
                                <template scope="scope">
                                    <span>{{ scope.row.negative_flag | lanchange}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <el-button type="primary" size="mini" @click="getSingleSORedLine" :disabled="!btn.getSingleSORedLine"
                        v-show="dataDetail.Head.negative_flag == 0 && dataDetail.Head.order_status > 0">{{$t('getapi[2236]')}}
                        </el-button>
                    </div>
                    <div style="width:950px;min-width:950px">
                        <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4168]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <routejump :urlNo="41" v-show="dataDetail.Head.order_status == 0 && dataDetail.MasterLists.length == 0">
                                <el-input  type="text" v-model="dataDetail.Head.so_code"
                                           readonly
                                           class="mcolor"
                                           size="mini"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectsocode()"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_code" v-show="dataDetail.Head.order_status != 0 || dataDetail.MasterLists.length > 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4527]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.routing_sequence_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4364]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.routing_sequence_name" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1419]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1420]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[4530]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_spec" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1862]') }}</td>
                            <td>
                                <el-input type="text" size="mini" :value="expFinanceStatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1857]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[2188]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[4469]') }}</td>
                            <td>
                                <routejump :urlNo="36">
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status == 0" class="mcolor">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status != 0" :readonly="true" class="readO">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4531]') }}</td>
                            <td colspan="5">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.remark"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.regist_person" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td colspan="4">
                                <el-checkbox  v-model="dataDetail.Head.negative_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>{{ $t('getapi[2096]') }}
                            </td>
                            <td v-if="dataDetail.Head.negative_flag == 1">{{ $t('getapi[7109]') }}</td>
                            <td v-if="dataDetail.Head.negative_flag == 1">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.base_order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1976]') }}</td>
                            <td>
                                <el-input type="text" size="mini" :value="expTypeNmae(dataDetail.Head.order_type)" :readonly="true" class="readO"></el-input>
                                <!-- <el-input type="text" size="mini" :disabled="true" v-model="dataDetail.Head.order_typename"></el-input> -->
                            </td>
                        </tr>
                    </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[4512]')" name="0">
                            <div>
                                <el-button type="primary" size="mini" @click="selectpart('')" :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1">{{ $t('getapi[878]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="getSingleSOIss" :disabled="!btn.getSingleSOIss">{{ $t('getapi[4571]') }}
                                </el-button>
                                <!--<el-button type="primary" size="mini" @click="batchDel" :disabled="dataDetail.Head.order_status != 0">{{
                                    $t('getapi[1522]') }}
                                </el-button>-->
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.MasterLists"
                                    :row-class-name="tableRowClassNameDetailMaster"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 180"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    :header-cell-style="$limits.headerClass"
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')" width="150">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input  type="text" v-model="scope.row.part_code"
                                                   readonly
                                                   class="mcolor"
                                                   size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column prop="mp_flag" :label="$t('getapi[4241]')">
                                    <template scope="scope">
                                        {{scope.row.mp_flag == 0?$t('getapi[235]'):$t('getapi[242]')}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>                                
                                <el-table-column prop="actually_avg_qty" :label="$t('getapi[1628]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input v-model="scope.row.actually_avg_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3100]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="inv_qty" :label="$t('getapi[2195]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_inv_qty" :label="$t('getapi[8966]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[4522]')" width="180"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                                <el-table-column prop="area_code" :label="$t('getapi[6900]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-select filterable class-name="check" v-model="scope.row.area_code">
                                            <el-option v-for="item in scope.row.areaarr" :key="item" :title="item"
                                                       :value="item" size="mini"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="50">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[1146]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delLists(scope)"
                                        >
                                            <el-button slot="reference" type="text" size="small" :disabled="dataDetail.Head.order_status != 0">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4524]')" name="1">
                            <div>
                                <el-button type="primary" size="mini" @click="selectpartassist('')" :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1">{{ $t('getapi[878]') }}
                                </el-button>
                                <!--<el-button type="primary" size="mini" @click="batchDelAssist" :disabled="dataDetail.Head.order_status != 0">{{
                                    $t('getapi[1522]') }}
                                </el-button>-->
                            </div>
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.MasterLists"
                                    :row-class-name="tableRowClassNameDetailAssist"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 180"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    :header-cell-style="$limits.headerClass"
                                    ref="singleTable4"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')" width="150">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input  type="text" v-model="scope.row.part_code"
                                                   readonly
                                                   class="mcolor"
                                                   size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpartassist(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column prop="mp_flag" :label="$t('getapi[4241]')">
                                    <template scope="scope">
                                        {{scope.row.mp_flag == 0?$t('getapi[235]'):$t('getapi[242]')}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>                                
                                <el-table-column prop="actually_avg_qty" :label="$t('getapi[1628]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input v-model="scope.row.actually_avg_qty" @input="changeQty(scope)" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3100]')"></el-table-column>
                                <el-table-column prop="assist_actually_avg_qty" :label="$t('getapi[2201]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input v-model="scope.row.assist_actually_avg_qty" @input="changeAssistQty(scope)" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="inv_qty" :label="$t('getapi[2195]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_inv_qty" :label="$t('getapi[8966]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[4522]')" width="180"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="50">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[1146]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delLists(scope)"
                                        >
                                            <el-button slot="reference" type="text" size="small" :disabled="dataDetail.Head.order_status != 0">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="area_code" :label="$t('getapi[6900]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-select filterable class-name="check" v-model="scope.row.area_code">
                                            <el-option v-for="item in scope.row.areaarr" :key="item" :title="item"
                                                       :value="item" size="mini"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSOCollecIssueHeadSingleViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4006]')" queryData="ProSOCollecIssueHeadSingleViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择物料-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/Pro/SingleSO/GetSinglePartPopupDataList'" @callback="getpart" ref="part"></selectorvxe>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SingleSO/GetSinglePartPopupDataList'" @callback="getpart" ref="partsingle"></selector>
        <!--选择次物料-->
        <selector :isVisible="false" :isBatch=true :postUrl="'/Pro/SingleSO/GetSinglePartPopupDataList'" @callback="getpartassist" ref="partassist"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SingleSO/GetSinglePartPopupDataList'" @callback="getpartassist" ref="partassistsingle"></selector>
        <!--选择SO号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SingleSO/GetSOCodePopupDataList'" @callback="getsocode" ref="socode"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetSingleSORedCargoPositionPopupList'" @callback="getcargo" ref="cargo"></selector>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--发料单号弹窗-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetSingleSOActionPopupDataList'" @callback="getorderno" ref="orderno"></selector>
        <!--发料单号红字弹窗-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetRedSingleSOPopupDataList'" @callback="getordernored" ref="ordernored"></selector>

        <el-dialog v-dialogDrag :visible.sync="visGuide" title="单SO发料向导" width="25%" :close-on-click-modal="false" >
            <table>
                <tr>
                    <td>
                        <el-radio v-model="flag" label="0">全部</el-radio>
                    </td>
                    <td>
                        <el-radio v-model="flag" label="1">手工输入</el-radio>
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td>
                        领料套数<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="tao" :readonly="flag==0" :class="{'readO':flag==0}" style="width:100px"></el-input>
                    </td>
                    <td>
                        <el-checkbox  v-model="cgj"  :true-label=1 :false-label=0 :disabled="flag==0"></el-checkbox>{{ $t('getapi[446]') }}
                    </td>
                    <td>
                        <el-checkbox  v-model="zzj"  :true-label=1 :false-label=0 :disabled="flag==0"></el-checkbox>{{ $t('getapi[2232]') }}
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visGuide = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmGetSingleSOIss" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="visProIssueExcute" width="80%" :close-on-click-modal="false" :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[2255]') }}</td>
                    <td style="width:150px;">
                       <!-- <el-input type="text" size="mini" v-model="dataDetailBlue.Head.order_no" :disabled="true"></el-input>-->
                        <el-input  type="text" v-model="dataDetailBlue.Head.order_no"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno"></i>
                        </el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4168]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailBlue.Head.so_code" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
            </table>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                <el-tab-pane :label="$t('getapi[4512]')" name="0" >
                    <el-table
                            :data="dataDetailBlue.IssueLists"
                            :row-class-name="tableRowClassNameDetailMaster"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1842]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2240]')" align="right"></el-table-column>
                        <!--<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2241]')" align="right"></el-table-column>-->
                        <el-table-column show-overflow-tooltip prop="sninvqty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column prop="actually_avg_qty" :label="$t('getapi[3103]')" align="right">
                            <template scope="scope">
                                <el-input v-model="scope.row.actually_avg_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3260]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="workproc_id" :label="$t('getapi[2246]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[2197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="field" :label="$t('getapi[115]')"></el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_order_no" :label="$t('getapi[2252]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_line_no" :label="$t('getapi[2253]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[4524]')" name="1">
                    <el-table
                            :data="dataDetailBlue.IssueLists"
                            :row-class-name="tableRowClassNameDetailAssist"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1842]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2240]')" align="right"></el-table-column>
                        <!--<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2241]')" align="right"></el-table-column>-->
                        <el-table-column show-overflow-tooltip prop="sninvqty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column prop="actually_avg_qty" :label="$t('getapi[3103]')" align="right">
                            <template scope="scope">
                                <el-input v-model="scope.row.actually_avg_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3260]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_qty_on_hand" :label="$t('getapi[2243]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assistsninvqty" :label="$t('getapi[2244]')"></el-table-column>
                        <el-table-column prop="assist_actually_avg_qty" :label="$t('getapi[2245]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.assist_actually_avg_qty" @change="changeAssistQtyBlue(scope)" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="workproc_id" :label="$t('getapi[2246]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[2197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="field" :label="$t('getapi[115]')"></el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_order_no" :label="$t('getapi[2252]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_line_no" :label="$t('getapi[2253]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visProIssueExcute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="saveSingleSOActionData(0)" :disabled="!btn.saveSingleSOActionData" size="mini">保存</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="visProIssueExcuteRed" width="80%" :close-on-click-modal="false" :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[2255]') }}</td>
                    <td style="width:150px;">
                        <!--<el-input type="text" size="mini" v-model="dataDetailRed.Head.order_no" :disabled="true"></el-input>-->
                        <el-input  type="text" v-model="dataDetailRed.Head.order_no"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectordernored"></i>
                        </el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4168]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailRed.Head.so_code" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:100px;"><el-checkbox  v-model="dataDetailRed.Head.negative_flag"  :true-label=1 :false-label=0 disabled="true"></el-checkbox>{{ $t('getapi[2096]') }}</td>
                    <td style="width:60px">原单据</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailRed.Head.base_order_no" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
            </table>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                <el-tab-pane :label="$t('getapi[4512]')" name="0">
                    <el-table
                            :data="dataDetailRed.IssueLists"
                            :row-class-name="tableRowClassNameDetailMaster"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column prop="cargo_position" :label="$t('getapi[1842]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[3103]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3260]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')" align="right"></el-table-column>
                        <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.batch_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.sequence_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="field" :label="$t('getapi[115]')"></el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_order_no" :label="$t('getapi[2252]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_line_no" :label="$t('getapi[2253]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[4524]')" name="1">
                    <el-table
                            :data="dataDetailRed.IssueLists"
                            :row-class-name="tableRowClassNameDetailAssist"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column prop="cargo_position" :label="$t('getapi[1842]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[3103]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[3260]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_actually_avg_qty" :label="$t('getapi[2245]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')" align="right"></el-table-column>
                        <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.batch_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.sequence_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="field" :label="$t('getapi[115]')"></el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_order_no" :label="$t('getapi[2252]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_line_no" :label="$t('getapi[2253]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visProIssueExcuteRed = false" :disabled="!btn.closeExecuteRed">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="saveRedSingleSOActionData" :disabled="!btn.saveRedSingleSOActionData" size="mini">保存</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="visPrintType" width="25%" :close-on-click-modal="false"  title="请选择打印单据类型">
            <table>
                <tr>
                    <td><el-radio v-model="printflag" label="0">生产领料单</el-radio></td>
                    <td><el-radio v-model="printflag" label="1">生产退料单</el-radio></td>
                </tr>
                <tr>
                    <td><el-radio v-model="printflag" label="2">生产领料单(A4)</el-radio></td>
                    <td><el-radio v-model="printflag" label="3">生产退料单(A4)</el-radio></td>
                </tr>
            </table>
        <span slot="footer" class="dialog-footer">
        <el-button @click="visPrintType	=	false" size='mini'>{{ $t('getapi[2054]') }}</el-button>
        <el-button type="primary" size='mini' @click="confirmPrint">确认打印</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_singlesoview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                visPrintType:false,//打印选择弹框
                printflag:'0',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_singlesoview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                RightSelectIndex: '0',
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_singlesoview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('2_singlesoview2'), // 当前页数据量
                total2: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail:{
                    Head:{},
                    MasterLists:[],
                    MergeLists:[],
                    LangType:0,
                },
                oldDataDetail: '',
                SignList: [],
                selectData: [],
                selectData1: [],
                selectData2: [],
                btn:{
                    getSingleSOIss: false,
                    getSingleSORedLine: false,
                    closeExecute: true,
                    saveSingleSOActionData: true,
                    closeExecuteRed: true,
                    saveRedSingleSOActionData: true,
                },
                visProIssueExcute: false, // 生产发料执行弹窗
                visProIssueExcuteRed: false, // 生产发料执行红字弹窗
                rowindex: '',
                oneormore: '',
                rowindexassist: '',
                oneormoreassist: '',
                dataDetailLineNo: 1,
                visGuide: false,
                flag: '0', //0:全部 1：手工输入 ,
                tao: '', // 套数
                cgj: 0, // 采购件
                zzj: 0, // 自制件
                dataDetailBlue: {
                    Head: {},
                    IssueLists: [],
                    iscontinue:0
                },
                dataDetailRed: {
                    Head: {},
                    IssueLists: []
                },
                rowindexcargo: '',
                issueDeptType: [], // 领料部门数组
                personType: 1, // 人员类型 1：保管员2：记账员
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
            };
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_singlesoview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.issueDeptType = Array.methods.getIssueDeptWithPFLAG();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            tableRowClassNameDetailMaster({row, rowIndex}){
                if (row.assist_measureunit != null && row.assist_measureunit != '') {
                    return 'hidden-row';
                }
                if(row.actually_avg_qty > row.inv_qty){
                    return 'red'
                }
            },
            tableRowClassNameDetailAssist({row, rowIndex}){
                if (row.assist_measureunit == null || row.assist_measureunit == '') {
                    return 'hidden-row';
                }
                if(row.actually_avg_qty > row.inv_qty){
                    return 'red'
                }
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSOCollecIssueHeadSingleViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            /*headerClass({row, column, rowIndex, columnIndex}){
                if(column.fixed == 'right'){
                    return 'background-color: #4db54d!important'
                }
            },*/
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4006]"),this.$t("getapi[6588]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority(type) {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (type == 1) {
                    //只读权
                    if (that.$limits.ReadOnlyRightsView('plv2', 182, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权限-查询级别
                    var limits = that.$limits.OperationAuthorityView('plv2', 182, 1, that.total);
                    // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                    switch (limits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        default:
                            break;
                    }
                }

                //管理界面
                if (type == 2) {
                    if (that.$limits.authority('plv2', 184, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 184, 1) == 2) {
						if (that.$limits.authority('plv3', 184,1) == 0) {
							that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
						}
                        //操作权
                        if (that.$limits.authority('plv3', 184,1) == 1) {
                            //编辑级
                            if(that.dataDetail.Head.order_type!=5){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            }
                            else{
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                            }
                        }
                        if (that.$limits.authority('plv3', 184, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status > 0){
                                    if(that.dataDetail.Head.order_type!=5){
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                    }
                                    else{
                                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                    }
                                } else {
                                    if(that.dataDetail.Head.order_type!=5){
                                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                    }
                                    else{
                                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                    }
                                }
                            } else {
                                if(that.dataDetail.Head.order_type!=5){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                                else{
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                }
                            }
                        }
                    }
                }
                if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.negative_flag == 0 && that.dataDetail.Head.order_no != ''){
                    console.log(that.$limits.authority('plv2', 279, 1))
                    if(that.$limits.authority('plv2', 279, 1) > 0){
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                } else if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.negative_flag == 1 && that.dataDetail.Head.order_no != ''){
                    if(that.$limits.authority('plv2', 280, 1) > 0){
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.getSingleSOIss = true
                if(that.$limits.authority('plv3', 184,1) == 0){
                    return
                } else {
                    if(that.$limits.authority('plv4', 324,1) == 0){
                        that.btn.getSingleSOIss = false
                    } else {
                        if(that.dataDetail.Head.so_code == ''){
                            that.btn.getSingleSOIss = false
                        }
                        if(that.dataDetail.Head.order_status != 0){
                            that.btn.getSingleSOIss = false
                        }
                        if(that.dataDetail.Head.negative_flag == 1){
                            that.btn.getSingleSOIss = false
                        }
                    }
                }
                that.btn.getSingleSORedLine = true
                if(that.dataDetail.Head.order_type==5){
                    that.btn.getSingleSORedLine = false
                }
                else{
                    if(that.$limits.authority('plv4', 327,1) == 0){
                        that.btn.getSingleSORedLine = false
                    }
                }
                
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_singlesoview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('2_singlesoview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('2_singlesoview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    //that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    //that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOCollecIssueHeadSingleViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pro/SingleSO/SingleSOViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$nextTick(function(){
                        that.$processdata.initAllForm()
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            print() {
            //询问
            let that = this;
            if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
            that.visPrintType = true;
            },
            confirmPrint(){
                let that = this;
                that.visPrintType = false;
                let TName = '16生产领料单.xlsx';
                if(that.printflag==1 || that.printflag==3){
                    TName = '17生产退料单.xlsx';
                }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.loading = true;
                let parm = {
                    po_no: that.dataDetail.Head.order_no,
                    TemplateName: TName
                };
                if(that.printflag==0 || that.printflag==1){
                    that.$http.urlpost('/Print/LLPrint', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('print', true);
                        if (res.Success == 1) {
                            let hrefurl = res.Key;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    });
                } else if(that.printflag==2 || that.printflag==3){
                    that.$http.urlpost('/Print/LLPrintA4', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('print', true);
                        if (res.Success == 1) {
                            let hrefurl = res.Key;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    });
                }
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    order_no:'',
                    so_code:'',
                    routing_sequence_no:'',
                    routing_sequence_name:'',
                    order_status:0,
                    order_status_name:'生成',
                    coll_sign:'',
                    boardspecial_flag:0,
                    finance_status:'',
                    finance_status_name:'',
                    finance_date:date,
                    issue_dept:'',
                    create_person:'',
                    create_time:date,
                    modify_person:'',
                    modify_time:'',
                    audit_person:'',
                    audit_time:'',
                    regist_person:'',
                    keep_person:'',
                    negative_flag:0,
                    base_order_no:'',
                    remark:'',
                    po_code:'',
                    vender_code:'',
                    vender_name:'',
                    verify_type:0,
                    order_type:0,
                    concurrent_time:'',
                    plan_qty: 0
                }
                that.dataDetail.MasterLists = []
                that.dataDetail.MergeLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority(2);
            },
            // 刷新
            reflash() {
                /*let that = this;
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/SingleSO/SingleSOViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSOCollecIssueHeadSingleViewInfo",
                    fromname: that.$t('getapi[4006]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                    delete that.dataDetail.MasterLists[i]['areaarr'];
                }
                that.$refs.SetBtn.SetOneBtnEnable('save',false);
                that.dataDetail.LangType= that.$processdata.getLang();
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Pro/SingleSO/SingleSOSave', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save',true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SingleSO/GetSingleSOBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                            if(that.dataDetail.MasterLists[i].area_code_list){
                                if(that.dataDetail.MasterLists[i].area_code_list.length > 0){
                                    that.dataDetail.MasterLists[i].areaarr = that.dataDetail.MasterLists[i].area_code_list.split(',')
                                } else {
                                    that.dataDetail.MasterLists[i].areaarr = []
                                }
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority(2);
                        that.btnauthority()
                    }
                    loadingInstance.close()
                    that.$nextTick(function(){
                        that.$processdata.initAllForm()
                    });
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            order_status: that.dataDetail.Head.order_status,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SingleSO/DelSingleSOBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            execute(){
                let that = this
                if(that.dataDetail.Head.negative_flag == 0){
                    that.visProIssueExcute = true
                    that.getSingleSOActionBillInfo(that.dataDetail.Head.order_no)
                    that.btn.saveSingleSOActionData = true
                } else {
                    that.visProIssueExcuteRed = true
                    that.getRedSingleSOActionBillInfo(that.dataDetail.Head.order_no)
                    that.btn.saveRedSingleSOActionData = true
                }
            },
            // 获取蓝字明细
            getSingleSOActionBillInfo(code){
                let that = this
                that.btn.saveSingleSOActionData = true
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetSingleSOActionBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailBlue = res.DataContent
                    }
                });
            },
            saveSingleSOActionData(value){
                let that = this
                that.dataDetailBlue.iscontinue=value
                let parm = that.dataDetailBlue
                parm.LangType = that.$processdata.getLang()
                that.btn.saveSingleSOActionData = false
                that.btn.closeExecute = false
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Inv/Action/SaveSingleSOData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    } else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.saveSingleSOActionData(res.Success)
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                    } else {
                        that.btn.saveSingleSOActionData = true
                    }
                    that.btn.closeExecute = true
                    loadingInstance.close()
                });
            },
            // 获取红字明细
            getRedSingleSOActionBillInfo(code){
                let that = this
                that.btn.saveRedSingleSOActionData = true
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetRedSingleSOActionBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailRed = res.DataContent
                    }
                });
            },
            saveRedSingleSOActionData(){
                let that = this
                let parm = that.dataDetailRed
                parm.LangType = that.$processdata.getLang()
                that.btn.saveRedSingleSOActionData = false
                that.btn.closeExecuteRed = false
                that.$http.urlpost('/Inv/Action/SaveRedSingleSOData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visProIssueExcuteRed = false
                        that.getDetail(that.code)
                    } else {
                        that.btn.saveRedSingleSOActionData = true
                    }
                    that.btn.closeExecuteRed = true
                });
            },
            selectsocode(){
                let that = this;
                that.$refs.socode.clearInput(true);
            },
            getsocode(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.part_code = data.part_code
                that.dataDetail.Head.part_version = data.part_version
                that.dataDetail.Head.routing_sequence_name = data.routing_desc
                that.dataDetail.Head.routing_sequence_no = data.routing_sequence_no
                that.dataDetail.Head.so_code = data.so_code
                that.dataDetail.Head.plan_qty = data.plan_finish_qty
                that.btnauthority()
            },
            selectpart(row){
                let that = this;
                let param = {
                    SelectIndex: 0,
                    negative_flag: that.dataDetail.Head.negative_flag,
                    order_no: that.dataDetail.Head.order_no,
                    so_code: that.dataDetail.Head.so_code,
                    routing_sequence_no: that.dataDetail.Head.routing_sequence_no
                }
                if(row != ''){
                    that.rowindex = row.$index
                    that.oneormore = 2
                    that.$refs.partsingle.clearInput(true,param);
                } else {
                    that.oneormore = 1
                    that.$refs.part.clearInput(true,param);
                }
            },
            // 从料表生成
            getSingleSOIss(){
                let that = this
                console.log("测试");
                if(that.dataDetail.MasterLists.length > 0){
                    that.$message.warning('已有明细行，料表生成无效！')
                    return
                }
                that.visGuide = true
            },
            confirmGetSingleSOIss(){
                console.log("测试1")
                let that = this
                if(that.cgj == 0 && that.zzj == 0 && that.flag == 1){
                    that.$message.warning('采购件和自制件必须至少选择一项!')
                    return
                }
                let mp_flag = ''
                if(that.cgj == 1 && that.zzj == 1){
                    mp_flag = 2
                } else if(that.cgj == 1 && that.zzj == 0){
                    mp_flag = 0
                } else if (that.cgj == 0 && that.zzj == 1){
                    mp_flag = 1
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    so_code: that.dataDetail.Head.so_code,
                    routing_sequence_no: that.dataDetail.Head.routing_sequence_no,
                    negative_flag: that.dataDetail.Head.negative_flag,
                    plan_qty: that.dataDetail.Head.plan_qty,
                    flg: that.flag,
                    tao: that.tao,
                    mp_flag: mp_flag
                }
                that.$http.urlpost('/Pro/SingleSO/GetSingleSOIssByStaff', parm, function (res) {
                    if (res.Success == 1) {
                        that.visGuide = false
                        let data = res.DataContent.MasterLists
                        that.dataDetailLineNo = 1
                        for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                            if (that.dataDetail.MasterLists[i].line_no >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = that.dataDetail.MasterLists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<data.length;i++){
                            that.dataDetail.MasterLists = [...that.dataDetail.MasterLists,{
                                exclusively_id:'',
                                relation_order_no:data[i].relation_order_no,
                                line_no:that.dataDetailLineNo ++,
                                relation_stuff_id:data[i].relation_stuff_id,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                part_name:data[i].part_name,
                                part_spec:data[i].part_spec,
                                part_model:data[i].part_model,
                                part_stuff:data[i].part_stuff,
                                mp_flag:data[i].mp_flag,
                                mp_flag_name:data[i].mp_flag_name,
                                so_code:data[i].so_code,
                                so_qty:data[i].so_qty,
                                routing_sequence_no:data[i].routing_sequence_no,
                                routing_desc:data[i].routing_desc,
                                measure_unit:data[i].measure_unit,
                                plan_qty:data[i].plan_qty,
                                assist_plan_qty:data[i].assist_plan_qty,
                                actually_avg_qty:data[i].plan_qty,
                                unit_price:data[i].unit_price,
                                line_net_total_amount:data[i].line_net_total_amount,
                                line_remark:data[i].line_remark,
                                po_line_id:data[i].po_line_id,
                                assist_actually_avg_qty:data[i].assist_plan_qty,
                                assist_measureunit:data[i].assist_measureunit,
                                master_assist_rate:data[i].master_assist_rate,
                                inv_qty:data[i].inv_qty,
                                assist_inv_qty:data[i].assist_inv_qty,                                
                                issue_material_unit:data[i].issue_material_unit,
                                issue_material_amount:data[i].issue_material_amount,
                                issue_man_unit:data[i].issue_man_unit,
                                issue_man_amount:data[i].issue_man_amount,
                                issue_charge_unit:data[i].issue_charge_unit,
                                issue_charge_amount:data[i].issue_charge_amount,
                                item_code:data[i].item_code,
                                workcenter_code:data[i].workcenter_code,
                                cargo_position:data[i].cargo_position,
                                create_qty:data[i].create_qty,
                                board_flag:data[i].board_flag,
                                assist_unit_flag:data[i].assist_unit_flag
                            }]
                        }
                        for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                            if(that.dataDetail.MasterLists[i].assist_unit_flag == 1){
                                if(that.dataDetail.MasterLists[i].board_flag == 1){
                                    that.dataDetail.MasterLists[i].actually_avg_qty = that.$processdata.mathRound2(that.dataDetail.MasterLists[i].assist_actually_avg_qty*that.dataDetail.MasterLists[i].master_assist_rate)
                                }
                            }
                        }
                    }
                });
            },
            getpart(data){
                let that = this
                console.log(data)
                that.dataDetailLineNo = 1
                if(that.oneormore == 1){
                    let arr = data.filter(item => {
                        return that.dataDetail.MasterLists.every(item2 => {
                            return (item.part_code + item.part_version) != (item2.part_code + item2.part_version);
                        });
                    });
                    data = arr
                    for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                        if (that.dataDetail.MasterLists[i].line_no >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.MasterLists[i].line_no + 1
                        }
                    }
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.MasterLists = [...that.dataDetail.MasterLists,{
                            exclusively_id:'',
                            relation_order_no:'',
                            line_no:that.dataDetailLineNo ++,
                            relation_stuff_id:data[i].relation_stuff_id,
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            part_model:data[i].part_model,
                            part_stuff:data[i].part_stuff,                            
                            mp_flag:data[i].mp_flag,
                            mp_flag_name:data[i].mp_flag_name,
                            so_code:data[i].so_code,
                            so_qty:data[i].so_stuff_qty,
                            routing_sequence_no:that.dataDetail.Head.routing_sequence_no,
                            routing_desc:null,
                            measure_unit:data[i].part_master_unit,
                            plan_qty:data[i].plan_qty,
                            assist_plan_qty:'',
                            actually_avg_qty:data[i].plan_qty,
                            unit_price:0,
                            line_net_total_amount:null,
                            line_remark:null,
                            po_line_id:0,
                            assist_actually_avg_qty:'',
                            assist_measureunit:'',
                            master_assist_rate:data[i].master_assist_rate,
                            inv_qty:data[i].inv_qty,
                            assist_inv_qty:data[i].assist_inv_qty,                            
                            issue_material_unit:0,
                            issue_material_amount:0,
                            issue_man_unit:0,
                            issue_man_amount:0,
                            issue_charge_unit:0,
                            issue_charge_amount:0,
                            item_code:null,
                            workcenter_code:null,
                            cargo_position:data[i].cargo_position,
                            create_qty:data[i].create_qty,
                            area_code_list:data[i].area_code_list
                        }]
                    }
                } else {
                    for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                        if(data.part_code + data.part_version == that.dataDetail.MasterLists[i].part_code + that.dataDetail.MasterLists[i].part_version){
                            that.$message.warning('数据已存在！')
                            return
                        }
                    }
                    that.dataDetail.MasterLists[that.rowindex].relation_stuff_id=data.relation_stuff_id
                    that.dataDetail.MasterLists[that.rowindex].part_code=data.part_code
                    that.dataDetail.MasterLists[that.rowindex].part_version=data.part_version
                    that.dataDetail.MasterLists[that.rowindex].part_name=data.part_name
                    that.dataDetail.MasterLists[that.rowindex].part_spec=data.part_spec
                    that.dataDetail.MasterLists[that.rowindex].part_model=data.part_model
                    that.dataDetail.MasterLists[that.rowindex].part_stuff=data.part_stuff                    
                    that.dataDetail.MasterLists[that.rowindex].mp_flag=data.mp_flag
                    that.dataDetail.MasterLists[that.rowindex].mp_flag_name=data.mp_flag_name
                    that.dataDetail.MasterLists[that.rowindex].so_code=data.so_code
                    that.dataDetail.MasterLists[that.rowindex].so_qty=data.so_stuff_qty
                    that.dataDetail.MasterLists[that.rowindex].measure_unit=data.part_master_unit
                    that.dataDetail.MasterLists[that.rowindex].plan_qty=data.plan_qty
                    that.dataDetail.MasterLists[that.rowindex].assist_measureunit=data.part_assist_unit
                    that.dataDetail.MasterLists[that.rowindex].master_assist_rate=data.master_assist_rate
                    that.dataDetail.MasterLists[that.rowindex].inv_qty=data.inv_qty
                    that.dataDetail.MasterLists[that.rowindex].assist_inv_qty=data.assist_inv_qty                    
                    that.dataDetail.MasterLists[that.rowindex].cargo_position=data.cargo_position
                    that.dataDetail.MasterLists[that.rowindex].create_qty=data.create_qty
                    that.dataDetail.MasterLists[that.rowindex].area_code_list=data.area_code_list
                }
                //初始化库区数组
                for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                    if(that.dataDetail.MasterLists[i].area_code_list != null && that.dataDetail.MasterLists[i].area_code_list.length > 0){
                        that.dataDetail.MasterLists[i].areaarr = that.dataDetail.MasterLists[i].area_code_list.split(',')
                    } else {
                        that.dataDetail.MasterLists[i].areaarr = []
                    }
                }
            },
            selectpartassist(row){
                let that = this;
                let param = {
                    SelectIndex: 1,
                    negative_flag: that.dataDetail.Head.negative_flag,
                    order_no: that.dataDetail.Head.order_no,
                    so_code: that.dataDetail.Head.so_code,
                    routing_sequence_no: that.dataDetail.Head.routing_sequence_no
                }
                if(row != ''){
                    that.rowindexassist = row.$index
                    that.oneormoreassist = 2
                    that.$refs.partassistsingle.clearInput(true,param);
                } else {
                    that.oneormoreassist = 1
                    that.$refs.partassist.clearInput(true,param);
                }

            },
            getpartassist(data){
                let that = this
                console.log(data)
                that.dataDetailLineNo = 1
                if(that.oneormoreassist == 1){
                    let arr = data.filter(item => {
                        return that.dataDetail.MasterLists.every(item2 => {
                            return (item.part_code + item.part_version) != (item2.part_code + item2.part_version);
                        });
                    });
                    data = arr;
                    for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                        if (that.dataDetail.MasterLists[i].line_no >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.MasterLists[i].line_no + 1
                        }
                    }
                    for(let i=0;i<data.length;i++){
                        that.dataDetail.MasterLists = [...that.dataDetail.MasterLists,{
                            exclusively_id:'',
                            relation_order_no:'',
                            line_no:that.dataDetailLineNo ++,
                            relation_stuff_id:data[i].relation_stuff_id,
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            part_model:data[i].part_model,
                            part_stuff:data[i].part_stuff,                            
                            mp_flag:data[i].mp_flag,
                            mp_flag_name:data[i].mp_flag_name,
                            so_code:data[i].so_code,
                            so_qty:data[i].so_stuff_qty,
                            routing_sequence_no:that.dataDetail.Head.routing_sequence_no,
                            routing_desc:null,
                            measure_unit:data[i].part_master_unit,
                            plan_qty:data[i].plan_qty,
                            assist_plan_qty:data[i].assist_plan_qty,
                            actually_avg_qty:data[i].plan_qty,
                            unit_price:0,
                            line_net_total_amount:null,
                            line_remark:null,
                            po_line_id:0,
                            assist_actually_avg_qty:data[i].assist_plan_qty,
                            assist_measureunit:data[i].part_assist_unit,
                            master_assist_rate:data[i].master_assist_rate,
                            inv_qty:data[i].inv_qty,
                            assist_inv_qty:data[i].assist_inv_qty,                            
                            issue_material_unit:0,
                            issue_material_amount:0,
                            issue_man_unit:0,
                            issue_man_amount:0,
                            issue_charge_unit:0,
                            issue_charge_amount:0,
                            item_code:null,
                            workcenter_code:null,
                            cargo_position:data[i].cargo_position,
                            create_qty:data[i].create_qty,
                            board_flag:data[i].board_flag,
                            assist_unit_flag:data[i].assist_unit_flag,
                            area_code_list:data[i].area_code_list
                        }]
                    }
                } else {
                    for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                        if(data.part_code + data.part_version == that.dataDetail.MasterLists[i].part_code + that.dataDetail.MasterLists[i].part_version){
                            that.$message.warning('数据已存在！')
                            return
                        }
                    }
                    that.dataDetail.MasterLists[that.rowindexassist].relation_stuff_id=data.relation_stuff_id
                    that.dataDetail.MasterLists[that.rowindexassist].part_code=data.part_code
                    that.dataDetail.MasterLists[that.rowindexassist].part_version=data.part_version
                    that.dataDetail.MasterLists[that.rowindexassist].part_name=data.part_name
                    that.dataDetail.MasterLists[that.rowindexassist].part_spec=data.part_spec
                    that.dataDetail.MasterLists[that.rowindexassist].part_model=data.part_model
                    that.dataDetail.MasterLists[that.rowindexassist].part_stuff=data.part_stuff                    
                    that.dataDetail.MasterLists[that.rowindexassist].mp_flag=data.mp_flag
                    that.dataDetail.MasterLists[that.rowindexassist].mp_flag_name=data.mp_flag_name
                    that.dataDetail.MasterLists[that.rowindexassist].so_code=data.so_code
                    that.dataDetail.MasterLists[that.rowindexassist].so_qty=data.so_stuff_qty
                    that.dataDetail.MasterLists[that.rowindexassist].measure_unit=data.part_master_unit
                    that.dataDetail.MasterLists[that.rowindexassist].plan_qty=data.plan_qty
                    that.dataDetail.MasterLists[that.rowindexassist].assist_measureunit=data.part_assist_unit
                    that.dataDetail.MasterLists[that.rowindexassist].master_assist_rate=data.master_assist_rate
                    that.dataDetail.MasterLists[that.rowindexassist].inv_qty=data.inv_qty
                    that.dataDetail.MasterLists[that.rowindexassist].assist_inv_qty=data.assist_inv_qty                    
                    that.dataDetail.MasterLists[that.rowindexassist].cargo_position=data.cargo_position
                    that.dataDetail.MasterLists[that.rowindexassist].create_qty=data.create_qty
                    that.dataDetail.MasterLists[that.rowindexassist].board_flag=data.board_flag
                    that.dataDetail.MasterLists[that.rowindexassist].assist_unit_flag=data.assist_unit_flag
                    that.dataDetail.MasterLists[that.rowindexassist].area_code_list=data.area_code_list
                }
                for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                    if(that.dataDetail.MasterLists[i].assist_unit_flag == 1){
                        if(that.dataDetail.MasterLists[i].board_flag == 1){
                            that.dataDetail.MasterLists[i].actually_avg_qty = that.$processdata.mathRound4(that.dataDetail.MasterLists[i].assist_actually_avg_qty * that.dataDetail.MasterLists[i].master_assist_rate)
                        }
                    }
                    
                    if(that.dataDetail.MasterLists[i].area_code_list != null && that.dataDetail.MasterLists[i].area_code_list.length > 0){
                        that.dataDetail.MasterLists[i].areaarr = that.dataDetail.MasterLists[i].area_code_list.split(',')
                    } else {
                        that.dataDetail.MasterLists[i].areaarr = []
                    }
                }
            },
            //生成红字单
            getSingleSORedLine(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no
                }
                that.$http.urlpost('/Pro/SingleSO/GetSingleSORedLineBySoCode', parm, function (res) {
                    if (res.Success == 1) {
                        let datetime = Common.methods.getDatetime()
                        that.dataDetail.Head.base_order_no = that.dataDetail.Head.order_no
                        that.dataDetail.Head.order_no = ''
                        that.dataDetail.Head.negative_flag = 1
                        that.dataDetail.Head.create_person = ''
                        that.dataDetail.Head.create_time = datetime
                        that.dataDetail.Head.finance_date = datetime
                        that.dataDetail.Head.order_status = 0
                        that.dataDetail.Head.order_status_name = '生成'
                        that.dataDetail.MasterLists = []
                        that.dataDetail.MergeLists =[]
                        
                        let data = res.DataContent.MasterLists
                        that.dataDetailLineNo = 1
                        for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                            if (that.dataDetail.MasterLists[i].line_no >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = that.dataDetail.MasterLists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<data.length;i++){
                            that.dataDetail.MasterLists = [...that.dataDetail.MasterLists,{
                                exclusively_id:'',
                                relation_order_no:data[i].relation_order_no,
                                line_no:data[i].line_no,
                                relation_stuff_id:data[i].relation_stuff_id,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                part_name:data[i].part_name,
                                part_spec:data[i].part_spec,
                                part_model:data[i].part_model,
                                part_stuff:data[i].part_stuff,                                
                                mp_flag:data[i].mp_flag,
                                mp_flag_name:data[i].mp_flag_name,
                                so_code:data[i].so_code,
                                so_qty:data[i].so_qty,
                                routing_sequence_no:data[i].routing_sequence_no,
                                routing_desc:data[i].routing_desc,
                                measure_unit:data[i].measure_unit,
                                plan_qty:data[i].plan_qty,
                                assist_plan_qty:data[i].assist_plan_qty,
                                actually_avg_qty:data[i].actually_avg_qty,
                                unit_price:data[i].unit_price,
                                line_net_total_amount:data[i].line_net_total_amount,
                                line_remark:data[i].line_remark,
                                po_line_id:data[i].po_line_id,
                                assist_actually_avg_qty:data[i].assist_actually_avg_qty,
                                assist_measureunit:data[i].assist_measureunit,
                                master_assist_rate:data[i].master_assist_rate,
                                inv_qty:data[i].inv_qty,
                                assist_inv_qty:data[i].assist_inv_qty,                                
                                issue_material_unit:data[i].issue_material_unit,
                                issue_material_amount:data[i].issue_material_amount,
                                issue_man_unit:data[i].issue_man_unit,
                                issue_man_amount:data[i].issue_man_amount,
                                issue_charge_unit:data[i].issue_charge_unit,
                                issue_charge_amount:data[i].issue_charge_amount,
                                item_code:data[i].item_code,
                                workcenter_code:data[i].workcenter_code,
                                cargo_position:data[i].cargo_position,
                                create_qty:data[i].create_qty,
                                area_code_list: data[i].area_code_list,
                                areaarr:[]
                            }]
                        }
                        for(let i = 0;i<that.dataDetail.MasterLists.length;i++){
                            if(that.dataDetail.MasterLists[i].area_code_list){
                                if(that.dataDetail.MasterLists[i].area_code_list.length > 0){
                                    that.dataDetail.MasterLists[i].areaarr = that.dataDetail.MasterLists[i].area_code_list.split(',')
                                } else {
                                    that.dataDetail.MasterLists[i].areaarr = []
                                }
                            }
                        }
                        let data1 = res.DataContent.MergeLists
                        for(let i = 0;i<data1.length;i++){
                            that.dataDetail.MergeLists = [...that.dataDetail.MergeLists,{
                                line_no:data[i].line_no,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                part_name:data[i].part_name,
                                part_spec:data[i].part_spec,
                                part_model:data[i].part_model,  
                                part_stuff:data[i].part_stuff,                                                             
                                measure_unit:data[i].measure_unit,
                                assist_measure_unit:data[i].assist_measure_unit,
                                merge_qty:data[i].merge_qty,
                                assist_merge_qty:data[i].assist_merge_qty,
                                master_assist_rate:data[i].master_assist_rate,
                                qty_on_hand:data[i].qty_on_hand,
                                createqty:data[i].createqty,
                                mp_flag:data[i].mp_flag,
                                cargo_position:data[i].cargo_position,
                            }]
                        }
                    }
                });
            },
            // 选择货位
            selectcargo(row){
                let that = this;
                that.rowindexcargo = row.$index
                that.$refs.cargo.clearInput(true);
            },
            getcargo(data){
                let that = this
                console.log(data)
                that.dataDetailRed.IssueLists[that.rowindexcargo].cargo_position = data.cargoposition_code
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            selectorderno(){
                let that = this;
                that.$refs.orderno.clearInput(true);
            },
            getorderno(data){
                let that = this
                that.dataDetailBlue.Head.order_no = data.order_no
                that.dataDetailBlue.Head.so_code = data.so_code
                that.getSingleSOActionBillInfo(that.dataDetailBlue.Head.order_no)
            },
            selectordernored(){
                let that = this;
                that.$refs.ordernored.clearInput(true);
            },
            getordernored(data){
                let that = this
                that.dataDetailRed.Head.order_no = data.order_no
                that.dataDetailRed.Head.so_code = data.so_code
                that.dataDetailRed.Head.negative_flag = data.negative_flag
                that.dataDetailRed.Head.base_order_no = data.base_order_no
                that.getRedSingleSOActionBillInfo(that.dataDetailRed.Head.order_no)
            },
            delLists(data){
                let that = this
                console.log(data.row)
                if(data.row.exclusively_id == ''){
                    that.dataDetail.MasterLists.splice(data.$index, 1);
                } else {
                    that.dataDetail.MasterLists.splice(data.$index, 1);
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        order_status: that.dataDetail.Head.order_status,
                        modify_time: that.dataDetail.Head.modify_time,
                        exclusively_id: data.row.exclusively_id,
                        part_code: data.row.part_code,
                        part_version: data.row.part_version
                    }
                    that.$http.urlpost('/Pro/SingleSO/DelSingleSORows', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.getDetail(that.code)
                        }
                        else{
                            that.getDetail(that.code)
                        }

                    })
                }
            },
            changeQty(row){
                let that = this
                let index = row.$index
                // if(that.dataDetail.MasterLists[index].board_flag == 1){
                if(that.dataDetail.MasterLists[index].assist_unit_flag == 1){
                        that.dataDetail.MasterLists[index].assist_actually_avg_qty = that.$processdata.mathRound3(that.dataDetail.MasterLists[index].actually_avg_qty / that.dataDetail.MasterLists[index].master_assist_rate)
                    // that.dataDetail.MasterLists[index].assist_actually_avg_qty=Math.round(that.dataDetail.MasterLists[index].assist_actually_avg_qty);
                }
            },
            // 详情次数量改变
            changeAssistQty(row){
                let that = this
                let index = row.$index
                that.dataDetail.MasterLists[index].actually_avg_qty = that.dataDetail.MasterLists[index].assist_actually_avg_qty * that.dataDetail.MasterLists[index].master_assist_rate
            },
            // 详情次数量改变
            changeAssistQtyBlue(row){
                let that = this
                let index = row.$index
                that.dataDetailBlue.IssueLists[index].actually_avg_qty = that.dataDetailBlue.IssueLists[index].assist_actually_avg_qty * that.dataDetailBlue.IssueLists[index].master_assist_rate
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[441]')//'关闭';
                } else {
                    return '';
                }
            },
            expTypeNmae(val) {
                let that = this
                if (val == 1) {
                    return that.$t('getapi[12584]')//'普通集成发料单';
                } else if (val == 2) {
                    return that.$t('getapi[12585]')//'板材专用发料单';
                }else if (val == 3) {
                    return that.$t('getapi[12586]')//'单SO发料单';
                }else if (val == 4) {
                    return that.$t('getapi[12587]')//'外协发料单';
                }else if (val == 5) {
                    return that.$t('getapi[12588]')//'回冲发料';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1901]')//'核算';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 184,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }

    /deep/.el-table .hidden-row {
        display: none;
    }
</style>
